import React from 'react';
import {css} from '@emotion/react';
import PropTypes from "prop-types";
import Header from "src/modules/editor-v2/Header";

MainDashboard.propTypes = {
    children: PropTypes.node.isRequired,
  };

export default function MainDashboard({children}){
  return (
    <div css={styles.container}>
        <Header type='LIGHT' studio={false}/>
        <div>
            {children}
        </div>
      
    </div>
  )
}


const styles={
    container:css`
      display:flex;
      flex-direction:column;
      width:100vw;
      min-height:calc(100vh - 71px);
      margin-top:71px;
      overflow: auto;
      scrollbar-width: none;
      ::-webkit-scrollbar {
        display: none;
      }
      `,
}